(function () {
    'use strict';

    angular.module("imApp").factory("sopMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1839,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
